import { getApiBaseUrl } from './apiClient';

export function buildTwitchSignInUrl(returnTo: string): string {
  return `${getApiBaseUrl()}/auth/twitch/start?return_to=${encodeURIComponent(returnTo)}`;
}

export function buildGoogleSignInUrl(returnTo: string): string {
  return `${getApiBaseUrl()}/auth/google/start?return_to=${encodeURIComponent(returnTo)}`;
}

export function buildDiscordConnectUrl(returnTo: string): string {
  return `${getApiBaseUrl()}/auth/discord/start?return_to=${encodeURIComponent(returnTo)}`;
}

export function buildYouTubeConnectUrl(returnTo: string): string {
  return `${getApiBaseUrl()}/auth/youtube/start?return_to=${encodeURIComponent(returnTo)}`;
}

export const DISCORD_AUTH_ERROR_MESSAGES: Record<string, string> = {
  discord_already_linked:
    'This Discord account is already linked to another Stream Center user.',
  discord_session_mismatch:
    'Discord connect failed because your session changed during sign-in. Please try again.',
  discord_session_required: 'Sign in with Twitch before connecting Discord.',
  discord_oauth_denied: 'Discord authorization was cancelled.',
  discord_token_exchange_failed: 'Discord sign-in failed. Please try again.',
  discord_profile_fetch_failed: 'Could not load your Discord profile. Please try again.',
  discord_user_not_found: 'Your Stream Center account could not be found.',
};

export const YOUTUBE_AUTH_ERROR_MESSAGES: Record<string, string> = {
  youtube_denied: 'YouTube authorization was cancelled or denied.',
  youtube_state: 'YouTube connect failed because the sign-in session expired. Please try again.',
  youtube_no_channel: 'No YouTube channel was found on this Google account.',
  youtube_no_refresh_token:
    'YouTube did not return a refresh token. Disconnect Google access for Scoutlytics and try again.',
};

export const LEGACY_USER_STORAGE_KEY = 'scoutlytics_user';

export function clearLegacyAuthStorage(): void {
  try {
    localStorage.removeItem(LEGACY_USER_STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear legacy auth storage:', error);
  }
}
